export const ADD_IDENTIFIER = 'ADD_IDENTIFIER';
export const DELETE_IDENTIFIER = 'DELETE_IDENTIFIER';
export const ADD_STUDENT_IDENTIFIER = 'ADD_STUDENT_IDENTIFIER';
export const DELETE_STUDENT_IDENTIFIER = 'DELETE_STUDENT_IDENTIFIER';

